import { useEffect } from 'react';
import BtnCheckBox from '../../BtnCheckBox/BtnCheckBox';
import useDebounce from '@/hooks/useDebounce';
import { isSubdomainAvailable } from '@/services/Api';
import InputText from '@/core/Input/InputText';
import InputNumber from '@/core/Input/InputNumber';

export default function Step2({ formikSignUpRealestate, setStep }) {
  const data = [
    { id: 1, name: 'خودم' },
    { id: 2, name: 'دیگران' },
  ];

  const selectHandler = (e) => {
    e.preventDefault();
    formikSignUpRealestate.setFieldValue('statusBusinessLicense', e.target.value);
  };

  const debouncedSearch = useDebounce(formikSignUpRealestate.values.subdomain, 500);

  const addRandomOneOrTwoDigitNumber = (baseString) => {
    const randomNum = Math.floor(Math.random() * 99) + 1; // عدد تصادفی بین 1 تا 99
    return `${baseString}${randomNum}`;
  };

  const sanitizeSubdomain = (input) => {
    return input
      .toLowerCase() // تبدیل همه چیز به حروف کوچیک
      .replace(/[^a-z0-9-]/g, '-') // جایگزین کردن هر چیزی غیر از a-z, 0-9 و - با -
      .replace(/^-+/, '') // حذف خط فاصله‌های اول
      .replace(/-+$/, '') // حذف خط فاصله‌های آخر
      .replace(/-+/g, '-') // تبدیل چند خط فاصله به یک خط فاصله
      .slice(0, 63) // محدود کردن به ۶۳ کاراکتر (حداکثر طول ساب‌دامین)
      .replace(/^[^a-z]+/, 'a'); // اگه با حرف شروع نشد، اجباری یک a اولش اضافه کن
  };

  const SubdomainAvailable = async (baseName) => {
    let currentName = sanitizeSubdomain(baseName);

    while (true) {
      try {
        const res = await isSubdomainAvailable(currentName + '.dubz.ir');
        if (res.status === true) {
          // پیدا شد
          return currentName;
        } else {
          // گرفته شده، تغییر بده
          currentName = addRandomOneOrTwoDigitNumber(baseName);
        }
      } catch (error) {
        console.error('Error checking subdomain:', error);
        break;
      }
    }
  };

  useEffect(() => {
    if (debouncedSearch == '' || formikSignUpRealestate.errors.subdomain) {
      formikSignUpRealestate.setFieldValue('subdomainOriginal', '');
    }
    const checkSubdomain = async () => {
      if (debouncedSearch && !formikSignUpRealestate.errors.subdomain) {
        const availableName = await SubdomainAvailable(debouncedSearch);
        formikSignUpRealestate.setFieldValue('subdomainOriginal', availableName + '.dubz.ir');
      }
    };

    checkSubdomain();
  }, [debouncedSearch]);

  return (
    <form
      onSubmit={formikSignUpRealestate.handleSubmit}
      className="grid grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-8 lg:gap-x-6 lg:gap-y-10 w-full max-w-[550px]"
    >
      <div className="flex items-center relative gap-4 col-span-2 lg:col-span-3 w-full">
        <label className="titleInput whitespace-nowrap" htmlFor="">
          وضعیت پروانه کسب
        </label>
        <div className="w-full flex flex-wrap items-center gap-3">
          {data.map((item) => (
            <BtnCheckBox
              key={item.name}
              nameEn={item.name}
              name={item.name}
              selectHandler={selectHandler}
              logic={formikSignUpRealestate.values.statusBusinessLicense == item.name}
              color="primary"
            />
          ))}
        </div>
        <span
          className={`text-[12px] text-error absolute -bottom-[22px] transition-all ${
            formikSignUpRealestate.errors.statusBusinessLicense && formikSignUpRealestate.touched.statusBusinessLicense
              ? 'visible opacity-100'
              : 'invisible opacity-0'
          }`}
        >
          {formikSignUpRealestate.errors.statusBusinessLicense}
        </span>
      </div>
      <div className="flex flex-col relative gap-1 col-span-2 lg:col-span-1">
        <InputText
          name="nameAgency"
          title="نام آژانس"
          placeholder="مثال : دابز"
          value={formikSignUpRealestate.values.nameAgency}
          errors={formikSignUpRealestate.errors.nameAgency}
          touched={formikSignUpRealestate.touched.nameAgency}
          handleBlur={formikSignUpRealestate.handleBlur}
          handleChange={formikSignUpRealestate.handleChange}
        />
      </div>
      <div className="flex flex-col relative gap-1 col-span-1 lg:col-span-1">
        <InputNumber
          name="telAgency"
          title="تلفن ثابت"
          placeholder="مثال : 0212478896"
          value={formikSignUpRealestate.values.telAgency}
          errors={formikSignUpRealestate.errors.telAgency}
          touched={formikSignUpRealestate.touched.telAgency}
          handleBlur={formikSignUpRealestate.handleBlur}
          handleChange={formikSignUpRealestate.handleChange}
        />
      </div>
      <div className="flex flex-col relative gap-1 col-span-1 lg:col-span-1">
        <InputNumber
          name="tradeID"
          title="شناسه صنفی"
          placeholder="باید 10 رقم باشد"
          value={formikSignUpRealestate.values.tradeID}
          errors={formikSignUpRealestate.errors.tradeID}
          touched={formikSignUpRealestate.touched.tradeID}
          handleBlur={formikSignUpRealestate.handleBlur}
          handleChange={formikSignUpRealestate.handleChange}
        />
      </div>
      <div className="flex flex-col relative gap-1 col-span-2 lg:col-span-3">
        <InputText
          name="subdomain"
          title="نام آژانس (به انگلیسی)"
          placeholder="bartar : مثال"
          dir="ltr"
          value={formikSignUpRealestate.values.subdomain}
          errors={formikSignUpRealestate.errors.subdomain}
          touched={formikSignUpRealestate.touched.subdomain}
          handleBlur={formikSignUpRealestate.handleBlur}
          handleChange={formikSignUpRealestate.handleChange}
        />
      </div>
      {!formikSignUpRealestate.errors.subdomain && formikSignUpRealestate.values.subdomainOriginal && (
        <div className="flex flex-col relative gap-1 col-span-2 lg:col-span-3">
          <div className="flex items-center justify-between w-full text-text-hard dark:text-white">
            <span>آدرس موقت آژانس شما:</span>
            <span>{formikSignUpRealestate.values.subdomainOriginal}</span>
          </div>
        </div>
      )}

      <div className="flex w-full items-center gap-4 col-span-2 lg:col-span-1">
        <button type="submit" className="btn btn-primary w-full lg:w-fit">
          تایید و ادامه
        </button>
        <button onClick={() => setStep(1)} className="btn border-[1px] border-primary text-primary w-full lg:w-fit">
          مرحله قبل
        </button>
      </div>
    </form>
  );
}
